import Pass from './Pass'

export default Pass
